<template>
  <div class="d-flex home justify-content-center">
    <Marketing />
  </div>
</template>

<script>
import Marketing from "../../components/Marketing/marketing.vue";

export default {
  components: {
    Marketing,
  },
};
</script>